import { TextField } from "@mui/material";
import FormControl from "@mui/material/FormControl";
import InputLabel from "@mui/material/InputLabel";
import MenuItem from "@mui/material/MenuItem";
import Select from "@mui/material/Select";
import Stack from "@mui/material/Stack";
import { AdapterDateFns } from "@mui/x-date-pickers/AdapterDateFns";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { TimePicker } from "@mui/x-date-pickers/TimePicker";
import React, { Fragment, useEffect, useState } from "react";
import persian from "react-date-object/calendars/persian";
import persian_fa from "react-date-object/locales/persian_fa";
import { Calendar } from "react-multi-date-picker";
import ShiftTimeTable from "../../../../Web/Common/ShiftTable/index";
import { changeHMtoDate, ConvertDate, removeSepMoney, sepJustMoney, sepMony, ToTimeHM } from "../../Function";
import BoxShadow from "../BoxShadow";
import Loading from "../Loading";
import CustomModal from "../Modal/CustomModal";
import TimeTable from "../TimeTable";
import { useEditTimeTable } from "./Hooks";
import { AiOutlinePlus } from "react-icons/ai";
import { useNavigate } from "react-router-dom";
import toast from "react-hot-toast";
import { AiOutlineLeft } from "react-icons/ai";
import { Spinner } from "react-bootstrap";
import { FormControlLabel, FormGroup, Switch } from "@mui/material";
import { RtlMui } from "../../../../App/component/rtlMui";
import { useSelector } from "react-redux";

function Edit({ item_id, reserve = {}, multi = {}, editBall, isApp, range = {}, SelectMethod, fsReserv }) {
  const { data, loading, getSingle, modal, setModal, form, setForm, updateTimeTable, newData, setNewData } = useEditTimeTable(isApp);
  useEffect(() => {
    getSingle(item_id);
  }, []);

  useEffect(() => {
    if (!modal.visible) {
      getSingle(item_id, modal.date);
    }
  }, [modal.visible]);

  if (loading.slug) {
    return <Loading count={1} col={12} height={"300px"} />;
  }
  if (data.showmodel == "list") {
    return (
      <>
        {/* ویرایش  مشخصات خردسال  */}
        {/* {!isApp && data?.option?.needchild == "true" && */}
        {!SelectMethod && (data?.option?.needchild == "true" &&
          !fsReserv &&
          <BoxShadow className={"mb-3 p-2 mt-2 " + (isApp && "shadow-none p-1 mb-4")}>
            <div className="d-flex align-items-end justify-content-start">

              <div className="form-group mb-0 ml-3">
                <label htmlFor="exampleInputEmail1">متن مشخصات خردسال</label>
                <input className="form-control"
                  onChange={({ target: { value } }) => {
                    setNewData({ ...newData, child: value });
                  }}
                  value={newData?.child}
                  style={isApp ? { fontSize: "12px", height: "30px", padding: " 2px 10px" } : {}}
                />
              </div>
              <button
                disabled={loading.update}
                onClick={() => {
                  updateTimeTable({
                    item_id: item_id,
                    action: "edit_options_values",
                    child: newData.child,
                  });
                }}
                className="btn btn-primary" >
                {loading.update ? "در حال بررسی" : "ویرایش"}
              </button>
            </div>
          </BoxShadow>
        )}

        <BoxShadow className={(isApp && "mt-2 mb-3 shadow-none p-1")}>
          <ShiftTimeTable
            SelectMethod={SelectMethod}
            reserve={reserve}
            status={modal.multi}
            isEdite={!fsReserv}
            multi={multi}
            stracture={{
              item: { Items: { id: item_id } },
              data: data,
              edit: {
                status: true,
                method: data => {
                  if (reserve.state) {
                    reserve.method({
                      ...modal,
                      visible: true,
                      ...data,
                      step: "select",
                      headerName: "ویرایش سانس"
                    });
                  } else {
                    setModal({
                      ...modal,
                      visible: true,
                      ...data,
                      step: "select",
                      headerName: "ویرایش سانس"
                    });
                  }
                },
              },
            }}
            isApp={isApp}
            activeMulti={modal["multi"]}
            btnHtml={!fsReserv && (
              <div className="d-flex mb-2 align-items-center justify-content-between">
                <div className="radioApp">
                  <FormGroup>
                    <FormControlLabel
                      onChange={() => {
                        setModal({ ...modal, multi: !modal.multi });
                      }}
                      control={<Switch />}
                      label={"انتخاب چند تایی"}
                      checked={modal["multi"]}
                      size={'sm'}
                    />
                  </FormGroup>
                </div>
                {modal.multi && multi && multi.arrLength() > 0 && (
                  <div className="d-flex mb-2 align-items-center justify-content-end">
                    <button
                      onClick={() => {
                        setModal({ ...modal, visible: true, step: "disiable", headerName: "آیا مطمئن هستید" });
                      }}
                      className="btn btn-primary" >
                      غیر فعال کردن
                    </button>
                    <button onClick={() => {
                      setModal({ ...modal, visible: true, step: "ghaderi", headerName: "برای فعال کردن سانس ظرفیت جدید را وارد کنید" });
                    }}
                      className="btn btn-primary mr-2" >
                      فعال کردن
                    </button>
                  </div>
                )}
              </div>
            )}
          />
          {!SelectMethod &&
            <div className="row mt-3">
              <div className="col">
                <button
                  className="btn btn-primary"
                  onClick={() => {
                    setModal({ visible: true, step: "add", headerName: "افزودن شیفت" });
                  }}
                >
                  شیفت جدید
                  <AiOutlinePlus color="#fff" style={{ color: "#fff" }} size={20} />
                </button>
              </div>
            </div>
          }

          <CustomModal
            className={"inputRight"}
            show={modal.visible}
            handleClose={() => {
              setModal({ ...modal, visible: false });
            }}
            header={modal.headerName ? modal.headerName : "ویرایش سانس"} >
            <RtlMui>
              <GuidShift
                data={{
                  item: { Items: { id: item_id } },
                  data: data,
                  time: modal,
                }}
                setModal={setModal}
                modal={modal}
                multi={multi}
                isApp={isApp}
              />
            </RtlMui>
          </CustomModal>
        </BoxShadow>
      </>
    );
  }
  else if (data.showmodel == "table") {
    const multiHtml = (setNewData, newData) => {
      return (
        <BoxShadow className={isApp && "mt-3 p-2 shadow-none p-1"} style={{ padding: "10px", margin: "0", marginBottom: "15px" }}>
          <div className="d-flex align-items-center justify-content-start">
            <div className="radioApp">
              <FormGroup>
                <FormControlLabel
                  onChange={() => {
                    setModal({ ...modal, multi: !modal.multi });
                  }}
                  control={<Switch />}
                  label={"انتخاب چند تایی"}
                  checked={modal["multi"]}
                  style={modal["range"] ? { pointerEvents: "none", opacity: "0.3" } : {}}
                />
                <FormControlLabel
                  onChange={() => {
                    setModal({ ...modal, range: !modal.range });
                  }}
                  control={<Switch />}
                  label={"انتخاب بازه‌ای"}
                  checked={modal["range"]}
                  className="inputOff"
                  style={modal["multi"] ? { pointerEvents: "none", opacity: "0.3" } : {}}
                />

              </FormGroup>
            </div>
          </div>

          {modal.multi && multi && multi.arrLength() > 0 && (
            <div className="d-flex my-2 align-items-center justify-content-start">
              <button
                onClick={() => {
                  setModal({ ...modal, visible: true, step: "disiable", headerName: "آیا مطمئن هستید" });
                }}
                className="btn btn-primary"
              >
                غیر فعال کردن
              </button>
              <button onClick={() => {
                setModal({ ...modal, visible: true, step: "ghaderi", headerName: "برای فعال کردن سانس ظرفیت جدید را وارد کنید" });
              }}
                className="btn btn-primary mx-2" >
                فعال کردن
              </button>
            </div>
          )}

          {modal.range && range && range.arrLength() > 0 && (
            <div className="row mx-0 justify-content-center">
              <div className={"d-flex align-items-center " + isApp ? "justify-content-center" : "justify-content-start"}>
                <div className={isApp && "col-12"}>
                  <Calendar
                    onChange={data => {
                      setNewData({
                        ...newData,
                        rangeStartDate: ConvertDate(
                          `${data.year}/${data.month.number}/${data.day}`
                        ),
                      });
                    }}
                    calendar={persian}
                    locale={persian_fa}
                  />
                </div>
                {!isApp && <span style={{ margin: "0 10px" }}></span>}
                <div className={isApp && "col-12 mt-2"}>
                  <Calendar
                    onChange={data => {
                      setNewData({
                        ...newData,
                        rangeEndDate: ConvertDate(
                          `${data.year}/${data.month.number}/${data.day}`
                        ),
                      });
                    }}
                    calendar={persian}
                    locale={persian_fa}
                  />
                </div>
              </div>

              <span style={{ margin: "0 10px" }}></span>

              <div className={"d-flex align-items-center justify-content-end " + isApp && "mt-3"}>
                <button onClick={() => {
                  setModal({ ...modal, visible: true, step: "disiable", headerName: "آیا مطمئن هستید" });
                }}
                  className="btn btn-primary" >
                  غیر فعال کردن
                </button>
                <button onClick={() => {
                  setModal({ ...modal, visible: true, step: "ghaderi", headerName: "برای فعال کردن سانس ظرفیت جدید را وارد کنید" });
                }}
                  className="btn btn-primary mx-2" >
                  فعال کردن
                </button>
              </div>
            </div>
          )}

        </BoxShadow >
      )
    }
    return (
      <>
        {!isApp && multi && multi.status && (
          multiHtml(setNewData, newData)
        )}

        {/* ویرایش قیمت توپ  */}
        {data?.option?.needballprice == "true" && (
          !fsReserv &&
          <BoxShadow className={"mb-3 p-2 mt-2"}>
            <div className="d-flex align-items-end justify-content-start">

              {editBall && <div className="form-group mb-0 ml-3">
                <label htmlFor="exampleInputEmail1">
                  ویرایش قیمت خرید توپ
                </label>
                <input
                  className="form-control"
                  onChange={({ target: { value } }) => {
                    setNewData({ ...newData, buyballprice: removeSepMoney(value) });
                  }}
                  value={sepJustMoney(newData?.buyballprice)}

                />
              </div>
              }

              <div className={"form-group mb-0 ml-3 "} >
                <label htmlFor="exampleInputEmail1">ویرایش قیمت اجاره توپ</label>
                <input className="form-control"
                  onChange={({ target: { value } }) => {
                    setNewData({ ...newData, ballprice: removeSepMoney(value) });
                  }}
                  value={sepJustMoney(newData?.ballprice)}
                  style={isApp ? { fontSize: "12px", height: "30px", padding: " 2px 10px" } : {}}
                />
              </div>

              <button
                disabled={loading.update}
                onClick={() => {
                  updateTimeTable({
                    item_id: item_id,
                    action: "edit_options_values",
                    // action: "edit",
                    ballprice: newData.ballprice,
                    buyballprice: newData.buyballprice,
                  });
                }}
                className="btn btn-primary" >
                {loading.update ? "در حال بررسی" : "ویرایش"}
              </button>
            </div>
          </BoxShadow>
        )}
        <div className={isApp && "mt-3 tdVAM"}>
          <TimeTable
            id={item_id}
            multi={multi}
            range={range}
            edit={{
              status: true,
              method: time => {
                if (reserve.state) {
                  reserve.method({ ...time, visible: true });
                } else {
                  setModal({ ...time, visible: true });
                }
              },
              date: modal.date,
            }}
            status={modal.multi}
            status2={modal.range}
            isApp={isApp}
          />
        </div>

        {isApp && multi && multi.status && (
          multiHtml(setNewData, newData)
        )}
        <CustomModal
          show={modal.visible}
          handleClose={() => {
            setModal({ ...modal, visible: false });
          }}
          // header="ویرایش سانس"
          header={modal.headerName ? modal.headerName : "ویرایش سانس"}
          className={"inputRight"}
        >
          <RtlMui>
            <GuidShift
              data={{
                item: { Items: { id: item_id } },
                data: data,
                time: modal,
              }}
              setModal={setModal}
              modal={modal}
              sans={true}
              multi={multi}
              range={range}
              isApp={isApp}
              newData={newData}
            />
          </RtlMui>
        </CustomModal>
      </>
    );
  }
  return <h2></h2>;
}

export default Edit;

const GuidShift = ({ data, setModal, modal, sans, multi = {}, range, isApp, newData }) => {

  const {
    updateTimeTable,
    loading,
    form,
    setForm,
    checkMobile,
    reserve,
    renderState,
  } = useEditTimeTable();
  const [newTime, setNewTime] = useState({ ...data.time });
  const navigate = useNavigate()
  const renderSteps = () => {
    switch (modal.step) {
      case 1:
        return (
          <EditTime
            data={data}
            setModal={setModal}
            sans={sans}
            updateTimeTable={updateTimeTable}
            loading={loading}
            modal={modal}
            isApp={isApp}
          />
        );
      case "add":
        return <AddShift data={data} setModal={setModal} modal={modal} isApp={isApp} />;
      case 2:
        return (
          <div>
            <div>
              <h6>
                مبلغی که در قسمت مبلغ با حساب تخفیف وارد میکنید مبلغی است که
                کاربر برای خرید این تایم پرداخت میکند.
              </h6>
            </div>
            <div className="row">
              <div className="col-md-6">

                <TextField
                  fullWidth
                  type="text"
                  min={0}
                  label={"مبلغ با حساب تخفیف"}
                  size="small"
                  value={sepJustMoney(newTime["second_price"])}
                  onChange={({ target: { value } }) => {
                    setNewTime({ ...newTime, second_price: removeSepMoney(value) });
                  }}
                />

              </div>
              {data.data.option?.needchild == "true" &&
                <div className="col-md-6">
                  <TextField
                    fullWidth
                    type="text"
                    min={0}
                    label={"مبلغ خردسال با حساب تخفیف"}
                    size="small"
                    value={sepJustMoney(newTime["second_child_price"])}
                    onChange={({ target: { value } }) => {
                      setNewTime({ ...newTime, second_child_price: removeSepMoney(value) });
                    }}
                  />
                </div>
              }
            </div>
            <div className="row">
              <div className="col-md-6 elements_sans" id="start">
                <label>پایان اعتبار تخفیف</label>
                <Calendar
                  onChange={data => {
                    setNewTime({
                      ...newTime,
                      second_exp: ConvertDate(
                        `${data.year}/${data.month.number}/${data.day}`
                      ),
                    });
                  }}
                  calendar={persian}
                  locale={persian_fa}
                />
              </div>
            </div>

            <div className="row mt-4">
              <div className="col">
                <button
                  className={"btn btn-primary " + (isApp && "w-100")}
                  disabled={loading.update}
                  onClick={() => {
                    updateTimeTable({
                      item_id: data.item.Items.id,
                      action: "edit",
                      ...newTime,
                      timekey: newTime.id,
                    });
                    setModal({ date: modal.date, visible: false });
                  }}
                >
                  {loading.update ? "در حال بررسی" : "ثبت تخفیف"}
                </button>
              </div>
            </div>
          </div>
        );
      case 3:
        return (
          <div>
            {sans ? (
              <div className="row">
                <div className="col-md-6">{`سانس ${`${newTime.start} تا ${newTime.end}`} حذف شود ؟؟`}</div>
              </div>
            ) : (
              <div className="row">
                <div className="col-md-6">{`شیفت ${newTime.title} حذف شود ؟؟`}</div>
              </div>
            )}

            <div className="row mt-3">
              <div className="col">
                <div>
                  <button
                    className={"btn btn-primary " + (isApp && "w-100")}
                    disabled={loading.update}
                    onClick={() => {
                      setModal({ ...modal, step: "select", headerName: "ویرایش سانس" });
                    }}
                  >
                    خیر
                  </button>
                </div>
              </div>
              <div className="col">
                <div>
                  <button
                    className={"btn btn-primary " + (isApp && "w-100")}
                    disabled={loading.update}
                    onClick={() => {
                      updateTimeTable({
                        item_id: data.item.Items.id,
                        action: "delete_time",
                        ...newTime,
                        timekey: newTime.id,
                      });
                      setModal({ date: modal.date, visible: false });
                    }}
                  >
                    {loading.update ? "در حال پردازش" : "بله"}
                  </button>
                </div>
              </div>
            </div>
          </div>
        );
      case 4:
        return (
          <div>
            <div className="row">
              <div className="col-6 mb-4">
                <TextField
                  fullWidth
                  type="number"
                  min={0}
                  label={"ظرفیت جدید"}
                  size="small"
                  onChange={({ target: { value } }) => {
                    setNewTime({ ...newTime, capacity: value });
                  }}
                  defaultValue={1}
                />
              </div>
            </div>
            <div className="row mt-3">
              <div className="col">
                <div>
                  <button
                    className={"btn btn-primary "}
                    disabled={loading.update}
                    onClick={() => {
                      updateTimeTable({
                        item_id: data.item.Items.id,
                        action: "change_capacity",
                        ...newTime,
                        timekey: newTime.id,
                        status: "active",
                      });
                      setModal({ date: modal.date, visible: false });
                    }}
                  >
                    {loading.update ? "در حال پردازش" : "بله"}
                  </button>
                </div>
              </div>
            </div>
          </div>
        );
      case 5:
        return (
          <div>
            <div className="row">
              {sans ? (
                <div className="col-md-6">{`سانس ${`${newTime?.start} تا ${newTime?.end}`} غیر فعال شود ؟؟`}</div>
              ) : (
                <div className="col-md-6">{`شیفت ${newTime?.title ? newTime?.title : ""} غیر فعال شود ؟؟`}</div>
              )}
            </div>{" "}
            <div className="row mt-3">
              <div className="col">
                <div>
                  <button
                    className={"btn btn-primary " + (isApp && "w-100")}
                    disabled={loading.update}
                    onClick={() => {
                      updateTimeTable({
                        item_id: data.item.Items.id,
                        action: "change_capacity",
                        ...newTime,
                        timekey: newTime.id,
                        status: "deactive",
                      });
                      setModal({ date: modal.date, visible: false });
                    }}
                  >
                    {loading.update ? "در حال پردازش" : "بله"}
                  </button>
                </div>
              </div>
            </div>
          </div>
        );
      case 6:
        return (
          <div className="container">
            <div className="row justify-content-center mb-4">
              <div className="col-md-6">
                <h6
                  className="text-center"
                  style={{ fontSize: "20px", margin: 0 }}
                >
                  مدیر مجموعه عزیز
                </h6>
                <p
                  className="text-center"
                  style={{ fontSize: "16px", margin: "0" }}
                >
                  برای رزرو ، شماره موبایل کاربر مورد نظر را وارد کنید
                </p>
              </div>
            </div>{" "}
            <div className="row mt-3 justify-content-center ">
              <div className="col-md-6">
                <div className="form-group d-flex">
                  <TextField
                    fullWidth
                    label={"شماره موبایل"}
                    size="small"
                    onChange={({ target: { value } }) => {
                      setForm({
                        item_id: data.item.Items.id,
                        ...form,
                        result: { user: "no" },
                        mobile: value,
                      });
                    }}
                    type="number"
                    length="11"
                  />
                  <button
                    onClick={() => checkMobile(modal, setModal)}
                    className="btn btn-primary mr-2"
                    disabled={loading.btn || form.mobile.length < 10}
                  >
                    {loading.btn ? (
                      <Spinner
                        as="span"
                        animation="border"
                        size="sm"
                        role="status"
                        aria-hidden="true"
                      />
                    ) : (
                      "ثبت"
                    )}
                  </button>
                </div>
              </div>
            </div>
            <div className="row justify-content-center">
              {/* <div className="col-md-6">{renderComponent()}</div> */}
            </div>
          </div>
        );
      case "reserve":
        return (
          <div className="mt-4 ">
            <div className="form-group">
              <TextField
                fullWidth
                label="نام و نام خانوادگی "
                size="small"
                value={form.fullname}
                disabled
              />
            </div>
            <div className="form-group">
              <TextField
                fullWidth
                label="کد ملی"
                size="small"
                type="number"
                value={form.national_code == false ? "" : form.national_code}
                disabled={renderState(form.national_code)}
                onChange={({ target: { value } }) => {
                  setForm({
                    ...form,
                    national_code: value,
                  });
                }}
              />
            </div>
            <div className="form-group">
              <TextField
                fullWidth
                label="شماره"
                size="small"
                type="number"
                value={form.mobile}
                disabled={form.mobile}
              />
            </div>
            <div className="mt-4">
              <button
                className={"btn btn-primary btn-block " + (isApp && "w-100")}
                onClick={() =>
                  reserve(
                    {
                      item_id: data.item.Items.id,
                      timekey: data.time.id,
                      daykey: data.time.daykey,
                      ...form,
                    },
                    setModal
                  )
                }
                disabled={
                  loading.reserve ||
                  !form.mobile ||
                  !form.national_code ||
                  !form.fullname
                }
              >
                {loading.reserve ? (
                  <Spinner
                    as="span"
                    animation="border"
                    size="sm"
                    role="status"
                    aria-hidden="true"
                  />
                ) : (
                  "رزرو"
                )}
              </button>
            </div>
          </div>
        );
      case "newuser":
        return (
          <div>
            <div className="form-group ">
              <label htmlFor="exampleInputEmail1">نام</label>
              <input
                className="form-control"
                onChange={({ target: { value } }) => {
                  setForm({ ...form, fullname: value });
                }}
              />
            </div>
            <div className="form-group">
              <label htmlFor="exampleInputPassword1">کد ملی</label>
              <input
                type="number"
                className="form-control"
                onChange={({ target: { value } }) => {
                  setForm({ ...form, national_code: value });
                }}
              />
            </div>
            <div className="form-group">
              <label htmlFor="exampleInputPassword1">شماره</label>
              <input
                type="number"
                className="form-control"
                value={form.mobile}
                disabled
              />
            </div>
            <div className="mt-4">
              <button
                className={"btn btn-primary btn-block" + (isApp && "w-100")}
                onClick={() =>
                  reserve(
                    {
                      item_id: data.item.Items.id,
                      timekey: data.time.id,
                      daykey: data.time.daykey,
                      ...form,
                    },
                    setModal
                  )
                }
                disabled={
                  loading.reserve ||
                  !form.mobile ||
                  !form.national_code ||
                  !form.fullname
                }
              >
                {loading.reserve ? (
                  <Spinner
                    as="span"
                    animation="border"
                    size="sm"
                    role="status"
                    aria-hidden="true"
                  />
                ) : (
                  "رزرو"
                )}
              </button>
            </div>
          </div>
        );
      case "disiable":
        return (
          <>
            {/* {console.log(newData)} */}
            {modal.multi &&
              <div className="d-flex flex-wrap">
                {multi && multi.renderTimes()}
              </div>
            }
            <div className="d-flex justify-content-end">
              <button
                className={"btn btn-primary " + (isApp && "w-100")}
                onClick={async () => {
                  if (modal.multi) {
                    await multi.submit(data.item.Items.id);
                  }
                  else {
                    if (!newData.rangeStartDate || !newData.rangeEndDate) {
                      toast.error(`لطفا تاریخ شروع و پایان را وارد کنید`);
                      return;
                    }
                    await range.submitRange(data.item.Items.id, null, 0, newData);
                  }
                  setModal({ date: modal.date, visible: false });
                }}
              >
                {multi.loading ? "غیر فعال کردن" : "در حال پردازش"}
              </button>
            </div >
          </>
        );

      case "ghaderi":
        return (
          <>
            {modal.multi &&
              <div className="d-flex flex-wrap">
                {multi && multi.renderTimes()}
              </div>
            }
            <div className="d-flex justify-content-between">
              <input
                placeholder="ظرفیت جدید"
                type="number"
                onChange={({ target: { value } }) => {
                  setModal({ ...modal, newGhaderi: value });
                }}
                className="form-control w-75"
              />
              <button
                className={"btn btn-primary "}
                onClick={async () => {

                  if (modal.multi) {
                    await multi.submit(
                      data.item.Items.id,
                      true,
                      modal.newGhaderi
                    );
                  }
                  else {
                    if (!newData.rangeStartDate || !newData.rangeEndDate) {
                      toast.error(`لطفا تاریخ شروع و پایان را وارد کنید`);
                      return;
                    }
                    await range.submitRange(data.item.Items.id, true, modal.newGhaderi, newData);
                  }

                  setModal({ date: modal.date, visible: false });
                }}
                defaultValue="1"
              >
                {multi.loading ? " فعال کردن" : "در حال پردازش"}
              </button>
            </div>
          </>
        );
      case "select":
      default:
        return (
          <div>

            {isApp &&
              <div className="position-relative border rounded p-3 mb-3">
                <span style={{ fontSize: "11px", position: "absolute", top: "-7px", background: "white", right: "8px", padding: "0 7px" }} >
                  اطلاعات سانس
                </span>

                <div className="infoItems d-flex justify-content-between pt-2" style={{ fontSize: "10px" }}>
                  <span>
                    قیمت سانس :{sepMony(data.time.price)} تومان
                  </span>
                  <span>
                    ظرفیت سانس : {data.time.capacity} نفر
                  </span>
                </div>
              </div>
            }
            <div className="d-flex justify-content-between flex-column border rounded pt-2">
              <button
                className="btn  mb-2 d-flex justify-content-between"
                onClick={() => setModal({ ...modal, step: 1, headerName: "ویرایش شیفت" })} >
                <span>
                  <svg style={{ marginLeft: "4px" }} xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 20 20" fill="none"><path d="M16.1051 4.81478C16.6668 5.65552 16.6668 6.82591 16.6668 9.16668C16.6668 11.5074 16.6668 12.6778 16.1051 13.5186C15.8618 13.8825 15.5493 14.195 15.1854 14.4383C14.4509 14.929 13.4649 14.991 11.6668 14.9988V15L10.7455 16.8426C10.4384 17.4568 9.56191 17.4568 9.25483 16.8426L8.3335 15V14.9988C6.53541 14.991 5.54939 14.929 4.81493 14.4383C4.45096 14.195 4.13846 13.8825 3.89526 13.5186C3.3335 12.6778 3.3335 11.5074 3.3335 9.16668C3.3335 6.82591 3.3335 5.65552 3.89526 4.81478C4.13846 4.45081 4.45096 4.13831 4.81493 3.89511C5.65567 3.33334 6.82606 3.33334 9.16683 3.33334H10.8335C13.1742 3.33334 14.3447 3.33334 15.1854 3.89511C15.5493 4.13831 15.8618 4.45081 16.1051 4.81478Z" stroke="#E42A3F" strokeLinecap="round" strokeLinejoin="round" /><path d="M7.5 7.5H12.5" stroke="#E42A3F" strokeLinecap="round" strokeLinejoin="round" /><path d="M7.5 10.8333H10" stroke="#E42A3F" strokeLinecap="round" strokeLinejoin="round" /></svg>
                  ویرایش {!sans ? "شیفت" : "سانس"}
                </span> <AiOutlineLeft />
              </button>

              <button
                className="btn  mb-2 d-flex justify-content-between"
                onClick={() => setModal({ ...modal, step: 2, headerName: "ثبت تخفیف" })}
              >
                <span>
                  <svg style={{ marginLeft: "4px" }} xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 20 20" fill="none"><path d="M16.1051 4.81478C16.6668 5.65552 16.6668 6.82591 16.6668 9.16668C16.6668 11.5074 16.6668 12.6778 16.1051 13.5186C15.8618 13.8825 15.5493 14.195 15.1854 14.4383C14.4509 14.929 13.4649 14.991 11.6668 14.9988V15L10.7455 16.8426C10.4384 17.4568 9.56191 17.4568 9.25483 16.8426L8.3335 15V14.9988C6.53541 14.991 5.54939 14.929 4.81493 14.4383C4.45096 14.195 4.13846 13.8825 3.89526 13.5186C3.3335 12.6778 3.3335 11.5074 3.3335 9.16668C3.3335 6.82591 3.3335 5.65552 3.89526 4.81478C4.13846 4.45081 4.45096 4.13831 4.81493 3.89511C5.65567 3.33334 6.82606 3.33334 9.16683 3.33334H10.8335C13.1742 3.33334 14.3447 3.33334 15.1854 3.89511C15.5493 4.13831 15.8618 4.45081 16.1051 4.81478Z" stroke="#E42A3F" strokeLinecap="round" strokeLinejoin="round" /><path d="M7.5 7.5H12.5" stroke="#E42A3F" strokeLinecap="round" strokeLinejoin="round" /><path d="M7.5 10.8333H10" stroke="#E42A3F" strokeLinecap="round" strokeLinejoin="round" /></svg>
                  ثبت تخفیف</span>
                <AiOutlineLeft />
              </button>
              <button
                className="btn  mb-2 d-flex justify-content-between"
                onClick={() => {
                  if (data.time) {
                    if (data.time.reservecount > 0) {
                      if (data.time.date) {
                        navigate(
                          `/Time/Reserve/${data.time.id}-${data.time.daykey}-${data.item.Items.id}`
                        );
                      } else {
                        navigate(`/Time/Reserve/${data.time.id}`);
                      }
                    } else {
                      toast.error(
                        `برای این ${sans ? "سانس" : "شیفت"} رزروی یافت نشد`
                      );
                    }
                  }
                }}
              >
                <span>
                  <svg style={{ marginLeft: "4px" }} xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 20 20" fill="none"><path d="M16.1051 4.81478C16.6668 5.65552 16.6668 6.82591 16.6668 9.16668C16.6668 11.5074 16.6668 12.6778 16.1051 13.5186C15.8618 13.8825 15.5493 14.195 15.1854 14.4383C14.4509 14.929 13.4649 14.991 11.6668 14.9988V15L10.7455 16.8426C10.4384 17.4568 9.56191 17.4568 9.25483 16.8426L8.3335 15V14.9988C6.53541 14.991 5.54939 14.929 4.81493 14.4383C4.45096 14.195 4.13846 13.8825 3.89526 13.5186C3.3335 12.6778 3.3335 11.5074 3.3335 9.16668C3.3335 6.82591 3.3335 5.65552 3.89526 4.81478C4.13846 4.45081 4.45096 4.13831 4.81493 3.89511C5.65567 3.33334 6.82606 3.33334 9.16683 3.33334H10.8335C13.1742 3.33334 14.3447 3.33334 15.1854 3.89511C15.5493 4.13831 15.8618 4.45081 16.1051 4.81478Z" stroke="#E42A3F" strokeLinecap="round" strokeLinejoin="round" /><path d="M7.5 7.5H12.5" stroke="#E42A3F" strokeLinecap="round" strokeLinejoin="round" /><path d="M7.5 10.8333H10" stroke="#E42A3F" strokeLinecap="round" strokeLinejoin="round" /></svg>
                  مشاهده رزرو های {sans ? "سانس" : "شیفت"}</span>
                <AiOutlineLeft />
              </button>
              <button
                className="btn  mb-2 d-flex justify-content-between"
                onClick={() => {
                  setModal({ ...modal, step: 6, headerName: "رزرو برای کاربر" });
                }}
              >
                <span><svg style={{ marginLeft: "4px" }} xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 20 20" fill="none"><path d="M16.1051 4.81478C16.6668 5.65552 16.6668 6.82591 16.6668 9.16668C16.6668 11.5074 16.6668 12.6778 16.1051 13.5186C15.8618 13.8825 15.5493 14.195 15.1854 14.4383C14.4509 14.929 13.4649 14.991 11.6668 14.9988V15L10.7455 16.8426C10.4384 17.4568 9.56191 17.4568 9.25483 16.8426L8.3335 15V14.9988C6.53541 14.991 5.54939 14.929 4.81493 14.4383C4.45096 14.195 4.13846 13.8825 3.89526 13.5186C3.3335 12.6778 3.3335 11.5074 3.3335 9.16668C3.3335 6.82591 3.3335 5.65552 3.89526 4.81478C4.13846 4.45081 4.45096 4.13831 4.81493 3.89511C5.65567 3.33334 6.82606 3.33334 9.16683 3.33334H10.8335C13.1742 3.33334 14.3447 3.33334 15.1854 3.89511C15.5493 4.13831 15.8618 4.45081 16.1051 4.81478Z" stroke="#E42A3F" strokeLinecap="round" strokeLinejoin="round" /><path d="M7.5 7.5H12.5" stroke="#E42A3F" strokeLinecap="round" strokeLinejoin="round" /><path d="M7.5 10.8333H10" stroke="#E42A3F" strokeLinecap="round" strokeLinejoin="round" /></svg>
                  رزرو برای کاربر</span>
                <AiOutlineLeft />
              </button>
              {console.log(data)}
              {(data.time.capacity && data.time.capacity == 0) ||
                !data.time.capacity ? (
                <button
                  className="btn  mb-2 d-flex justify-content-between"
                  onClick={() => {
                    setModal({ ...modal, step: 4, headerName: "ویرایش سانس " });
                    setNewTime({ ...newTime, capacity: 1 });
                  }}
                >
                  <span><svg style={{ marginLeft: "4px" }} xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 20 20" fill="none"><path d="M16.1051 4.81478C16.6668 5.65552 16.6668 6.82591 16.6668 9.16668C16.6668 11.5074 16.6668 12.6778 16.1051 13.5186C15.8618 13.8825 15.5493 14.195 15.1854 14.4383C14.4509 14.929 13.4649 14.991 11.6668 14.9988V15L10.7455 16.8426C10.4384 17.4568 9.56191 17.4568 9.25483 16.8426L8.3335 15V14.9988C6.53541 14.991 5.54939 14.929 4.81493 14.4383C4.45096 14.195 4.13846 13.8825 3.89526 13.5186C3.3335 12.6778 3.3335 11.5074 3.3335 9.16668C3.3335 6.82591 3.3335 5.65552 3.89526 4.81478C4.13846 4.45081 4.45096 4.13831 4.81493 3.89511C5.65567 3.33334 6.82606 3.33334 9.16683 3.33334H10.8335C13.1742 3.33334 14.3447 3.33334 15.1854 3.89511C15.5493 4.13831 15.8618 4.45081 16.1051 4.81478Z" stroke="#E42A3F" strokeLinecap="round" strokeLinejoin="round" /><path d="M7.5 7.5H12.5" stroke="#E42A3F" strokeLinecap="round" strokeLinejoin="round" /><path d="M7.5 10.8333H10" stroke="#E42A3F" strokeLinecap="round" strokeLinejoin="round" /></svg>
                    فعال کردن</span>
                  <AiOutlineLeft />
                </button>
              ) : (
                <button
                  className="btn  mb-2 d-flex justify-content-between"
                  onClick={() => setModal({ ...modal, step: 5, headerName: "غیر فعال کردن " })}
                >
                  <span><svg style={{ marginLeft: "4px" }} xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 20 20" fill="none"><path d="M16.1051 4.81478C16.6668 5.65552 16.6668 6.82591 16.6668 9.16668C16.6668 11.5074 16.6668 12.6778 16.1051 13.5186C15.8618 13.8825 15.5493 14.195 15.1854 14.4383C14.4509 14.929 13.4649 14.991 11.6668 14.9988V15L10.7455 16.8426C10.4384 17.4568 9.56191 17.4568 9.25483 16.8426L8.3335 15V14.9988C6.53541 14.991 5.54939 14.929 4.81493 14.4383C4.45096 14.195 4.13846 13.8825 3.89526 13.5186C3.3335 12.6778 3.3335 11.5074 3.3335 9.16668C3.3335 6.82591 3.3335 5.65552 3.89526 4.81478C4.13846 4.45081 4.45096 4.13831 4.81493 3.89511C5.65567 3.33334 6.82606 3.33334 9.16683 3.33334H10.8335C13.1742 3.33334 14.3447 3.33334 15.1854 3.89511C15.5493 4.13831 15.8618 4.45081 16.1051 4.81478Z" stroke="#E42A3F" strokeLinecap="round" strokeLinejoin="round" /><path d="M7.5 7.5H12.5" stroke="#E42A3F" strokeLinecap="round" strokeLinejoin="round" /><path d="M7.5 10.8333H10" stroke="#E42A3F" strokeLinecap="round" strokeLinejoin="round" /></svg>
                    غیر فعال کردن</span>
                  <AiOutlineLeft />
                </button>
              )}
              {!sans && (
                <button
                  className="btn  mb-2 d-flex justify-content-between"
                  onClick={() => setModal({ ...modal, step: 3, headerName: "حذف شیفت " })}
                >
                  <span><svg style={{ marginLeft: "4px" }} xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 20 20" fill="none"><path d="M16.1051 4.81478C16.6668 5.65552 16.6668 6.82591 16.6668 9.16668C16.6668 11.5074 16.6668 12.6778 16.1051 13.5186C15.8618 13.8825 15.5493 14.195 15.1854 14.4383C14.4509 14.929 13.4649 14.991 11.6668 14.9988V15L10.7455 16.8426C10.4384 17.4568 9.56191 17.4568 9.25483 16.8426L8.3335 15V14.9988C6.53541 14.991 5.54939 14.929 4.81493 14.4383C4.45096 14.195 4.13846 13.8825 3.89526 13.5186C3.3335 12.6778 3.3335 11.5074 3.3335 9.16668C3.3335 6.82591 3.3335 5.65552 3.89526 4.81478C4.13846 4.45081 4.45096 4.13831 4.81493 3.89511C5.65567 3.33334 6.82606 3.33334 9.16683 3.33334H10.8335C13.1742 3.33334 14.3447 3.33334 15.1854 3.89511C15.5493 4.13831 15.8618 4.45081 16.1051 4.81478Z" stroke="#E42A3F" strokeLinecap="round" strokeLinejoin="round" /><path d="M7.5 7.5H12.5" stroke="#E42A3F" strokeLinecap="round" strokeLinejoin="round" /><path d="M7.5 10.8333H10" stroke="#E42A3F" strokeLinecap="round" strokeLinejoin="round" /></svg>
                    حذف شیفت</span>
                  <AiOutlineLeft />
                </button>
              )}
            </div>
          </div>
        );
    }
  };
  return renderSteps();
};

const EditTime = ({
  data: {
    data: { option },
    item: {
      Items: { id },
    },
    time,
  },
  setModal,
  sans,
  updateTimeTable,
  loading,
  modal,
  isApp
}) => {
  const { user_type } = useSelector(state => state);
  const [newTime, setNewTime] = useState({ ...time });
  const isValid = type => {
    let result = false;
    if (type == "default") {
      result = true;
    } else {
      if (option && option[type] == "true") {
        result = true;
      }
    }
    return result;
  };
  const renderInputs = ({ input, label, key, type, disabled }) => {
    switch (input) {
      case "number":
        if (isValid(type)) {
          return (
            <div className="col-md-4 mb-4 ">
              <TextField
                fullWidth
                type="text"
                min={0}
                label={label}
                size="small"
                value={sepJustMoney(newTime[key])}
                onChange={({ target: { value } }) => {
                  setNewTime({ ...newTime, [key]: removeSepMoney(value) });
                }}
                disabled={disabled}
              />
            </div>
          );
        }
        break;

      case "time":
        if (sans && (key == "start" || key == "end")) {
          return;
        }
        return (
          <div className="col-md-4 mb-4">
            <LocalizationProvider dateAdapter={AdapterDateFns} key={key}>
              <Stack spacing={3}>
                <TimePicker
                  ampm={false}
                  size="small"
                  openTo="hours"
                  views={["hours", "minutes"]}
                  minutesStep={5}
                  inputFormat="HH:mm"
                  mask="__:__"
                  label={label}
                  value={changeHMtoDate(newTime[key]) || new Date()}
                  onChange={newValue => {
                    setNewTime({
                      ...newTime,
                      [key]: ToTimeHM(newValue),
                      [key + "s"]: newValue,
                    });
                  }}
                  renderInput={params => <TextField {...params} />}
                />
              </Stack>
            </LocalizationProvider>{" "}
          </div>
        );
      case "select":
        if (isValid(type)) {
          return (
            <div className="col-md-4 mb-4">
              <FormControl fullWidth>
                <InputLabel id="demo-simple-select-label">{label}</InputLabel>
                <Select
                  labelId="demo-simple-select-label"
                  id="demo-simple-select"
                  label={label}
                  onChange={({ target: { value } }) => {
                    setNewTime({ ...newTime, gender: value });
                  }}
                  defaultValue={newTime[key]}
                >
                  {[
                    {
                      label: "انتخاب کنید",
                      key: "false",
                    },
                    {
                      label: "آقایان",
                      key: "man",
                    },
                    {
                      label: "بانوان",
                      key: "woman",
                    },
                  ].map((option, key) => {
                    return (
                      <MenuItem value={option.key}> {option.label}</MenuItem>
                    );
                  })}
                </Select>
              </FormControl>
            </div>
          );
        }

        break;

      case "date":
        break;
      case "text":
        if (isValid(type)) {
          return (
            <div className="col-12 mb-4">
              <TextField
                fullWidth
                label={label}
                size="small"
                value={newTime[key]}
                onChange={({ target: { value } }) => {
                  setNewTime({ ...newTime, [key]: value });
                }}
              />
            </div>
          );
        }
        break;

      default:
        break;
    }
  };

  return (
    <Fragment>
      <div className="row">
        {[
          {
            type: "needtitle",
            input: "text",
            key: "title",
            label: "عنوان",
          },
          {
            type: "needgender",
            input: "select",
            key: "gender",
            label: "جنسیت",
          },
          {
            type: "needcapacity",
            input: "number",
            key: "capacity",
            label: "ظرفیت",
          },
          {
            type: "needsession",
            input: "number",
            key: "session",
            label: "تعداد جلسات",
          }
        ].map(input => {
          return renderInputs(input);
        })}
      </div>
      <div className="row">
        {
          [

            {
              type: "default",
              input: "time",
              key: "start",
              label: "شروع",
            },
            {
              type: "default",
              input: "time",
              key: "end",
              label: "پایان",
            },

          ].map(input => {
            return renderInputs(input);
          })
        }
      </div>
      <div className="row">
        {
          [
            {
              type: "default",
              input: "number",
              key: "buyprice",
              label: option?.needchild ? "قیمت خرید بزرگسال" : "قیمت خرید",
              disabled: user_type == "manager" && true,
              isHidden: user_type == "manager" && true
            },
            {
              type: "default",
              input: "number",
              key: "price",
              label: option?.needchild ? "قیمت فروش بزرگسال" : "قیمت فروش",
            },
            {
              type: "default",
              input: "number",
              key: "boxofficeprice",
              label: option?.needchild ? "قیمت گیشه بزرگسال" : "قیمت گیشه ",
              isHidden: user_type == "manager" && true
            },
            {
              type: "needchild",
              input: "number",
              key: "buychildprice",
              label: "قیمت خرید خردسال",
              disabled: user_type == "manager" && true,
              isHidden: user_type == "manager" && true
            },
            {
              type: "needchild",
              input: "number",
              key: "childprice",
              label: "قیمت فروش خردسال",
            },
            {
              type: "needchild",
              input: "number",
              key: "boxofficechildprice",
              label: "قیمت گیشه خردسال",
              isHidden: user_type == "manager" && true
            },
          ].map(input => {
            return !input.isHidden && renderInputs(input);
          })
        }
      </div>
      <div className="row">
        <div className="col-12 d-flex align-items-center justify-content-end">

          <button
            disabled={loading.update}
            onClick={() => {
              updateTimeTable({
                item_id: id,
                action: "edit",
                ...newTime,
                timekey: newTime.id,
              }).then(res => {
                setModal({ date: modal.date, visible: false });
              })
            }}
            className={"btn btn-primary " + (isApp && "w-100")}
          >
            {loading.update ? "در حال بررسی" : "ثبت"}
          </button>
        </div>
      </div>
    </Fragment>
  );
};

const AddShift = ({
  data: {
    data: { option },
    item: {
      Items: { id },
    },
    time,
  },
  setModal,
  modal,
  isApp
}) => {
  const { user_type } = useSelector(state => state);
  const { updateTimeTable, loading } = useEditTimeTable();
  const [newTime, setNewTime] = useState({});
  const isValid = type => {
    let result = false;
    if (type == "default") {
      result = true;
    } else {
      if (option && option[type] == "true") {
        result = true;
      }
    }
    return result;
  };
  const form = null;

  const renderInputs = ({ input, label, key, type }) => {
    switch (input) {
      case "number":
        if (isValid(type)) {
          return (
            <div className={"mb-4 " + (isApp ? "col-6" : "col-4")}>
              <TextField
                fullWidth
                type="text"
                min={0}
                label={label}
                size="small"
                value={sepJustMoney(newTime[key])}
                onChange={({ target: { value } }) => {
                  setNewTime({ ...newTime, [key]: removeSepMoney(value) });
                }}
              />
            </div>
          );
        }
        break;

      case "time":
        return (
          <div className={"mb-4 " + (isApp ? "col-6" : "col-4")}>
            <LocalizationProvider dateAdapter={AdapterDateFns} key={key}>
              <Stack spacing={3}>
                <TimePicker
                  ampm={false}
                  size="small"
                  openTo="hours"
                  views={["hours", "minutes"]}
                  minutesStep={5}
                  inputFormat="HH:mm"
                  mask="__:__"
                  label={label}
                  value={newTime[key + "s"] || new Date()}
                  onChange={newValue => {
                    setNewTime({
                      ...newTime,
                      [key]: ToTimeHM(newValue),
                      [key + "s"]: newValue,
                    });
                  }}
                  renderInput={params => <TextField {...params} />}
                />
              </Stack>
            </LocalizationProvider>{" "}
          </div>
        );
      case "select":
        if (isValid(type)) {
          return (
            <div className={"mb-4 " + (isApp ? "col-6" : "col-4")}>
              <FormControl fullWidth>
                <InputLabel id="demo-simple-select-label">{label}</InputLabel>
                <Select
                  labelId="demo-simple-select-label"
                  id="demo-simple-select"
                  label={label}
                  onChange={({ target: { value } }) => {
                    setNewTime({ ...newTime, gender: value });
                  }}
                >
                  {[
                    {
                      label: "انتخاب کنید",
                      key: "false",
                    },
                    {
                      label: "آقایان",
                      key: "man",
                    },
                    {
                      label: "بانوان",
                      key: "woman",
                    },
                  ].map((option, key) => {
                    return (
                      <MenuItem value={option.key} key={key}>
                        {" "}
                        {option.label}
                      </MenuItem>
                    );
                  })}
                </Select>
              </FormControl>
            </div>
          );
        }

        break;

      case "date":
        if (isValid(type)) {
          return (
            <div className="col-12 mb-4">
              <Calendar
                onChange={data => {
                  setNewTime({
                    ...newTime,
                    [key]: ConvertDate(
                      `${data.year}/${data.month.number}/${data.day}`
                    ),
                  });
                }}
                calendar={persian}
                locale={persian_fa}
              />
            </div>
          );
        }
        break;
      case "text":
        if (isValid(type)) {
          return (
            <div className="col-12 mb-4">
              <TextField
                fullWidth
                label={label}
                size="small"
                value={newTime[key]}
                onChange={({ target: { value } }) => {
                  setNewTime({ ...newTime, [key]: value });
                }}
              />
            </div>
          );
        }
        break;

      default:
        break;
    }
  };

  return (
    <Fragment>
      <div className="row">
        {[
          {
            type: "needtitle",
            input: "text",
            key: "title",
            label: "عنوان",
          },

          {
            type: "needgender",
            input: "select",
            key: "gender",
            label: "جنسیت",
          },

          {
            type: "needcapacity",
            input: "number",
            key: "capacity",
            label: "ظرفیت",
          },
          {
            type: "needsession",
            input: "number",
            key: "session",
            label: "تعداد جلسات",
          },
          {
            type: "default",
            input: "time",
            key: "start",
            label: "شروع",
          },
          {
            type: "default",
            input: "time",
            key: "end",
            label: "پایان",
          },
          {
            type: "default",
            input: "number",
            key: "buyprice",
            label: option?.needchild ? "قیمت خرید بزرگسال" : "قیمت خرید",
            disabled: user_type == "manager" && true,
            isHidden: user_type == "manager" && true
          },
          {
            type: "default",
            input: "number",
            key: "price",
            label: option?.needchild ? "قیمت فروش بزرگسال" : "قیمت فروش",
          },
          {
            type: "default",
            input: "number",
            key: "boxofficeprice",
            label: option?.needchild ? "قیمت گیشه بزرگسال" : "قیمت گیشه ",
            isHidden: user_type == "manager" && true
          },
          {
            type: "needchild",
            input: "number",
            key: "buychildprice",
            label: "قیمت خرید خردسال",
            disabled: user_type == "manager" && true,
            isHidden: user_type == "manager" && true
          },
          {
            type: "needchild",
            input: "number",
            key: "childprice",
            label: "قیمت فروش خردسال",
          },
          {
            type: "needchild",
            input: "number",
            key: "boxofficechildprice",
            label: "قیمت گیشه خردسال",
            isHidden: user_type == "manager" && true
          },
          {
            type: "needdate",
            input: "date",
            key: "date",
            label: "تاریخ",
          },
        ].map(input => {
          return !input.isHidden && renderInputs(input);
        })}
        <div className="col-12 d-flex align-items-center justify-content-end">
          <button
            disabled={loading.update}
            onClick={() => {
              if (newTime.date) {
                updateTimeTable({
                  item_id: id,
                  action: "add_time",
                  newtime: newTime,
                  date: newTime.date,
                });
              } else {
                updateTimeTable({
                  item_id: id,
                  action: "add_time",
                  newtime: newTime,
                });
              }

              setModal({ date: modal.date, visible: false });
            }}
            className={"btn btn-primary " + (isApp && "w-100")}
          >
            {loading.update ? "در حال بررسی" : "ثبت"}
          </button>
        </div>
      </div>
    </Fragment>
  );
};
